import { Button, Icon } from '@orionprotocol/ui';
import { Trans } from '@lingui/react';

import { CONNECT_WALLET_CLICK, useAnalytics } from '../../../shared/analytics';
import { useDialog } from '../../../shared/context';

import styles from './ConnectWalletButton.module.scss';

type ConnectWalletButtonProps = {
  className?: string;
};

export function ConnectWalletButton({
  className,
}: ConnectWalletButtonProps): JSX.Element {
  const { sendEvent } = useAnalytics();

  const { openDialog } = useDialog();

  const handleConnect = (): void => {
    sendEvent(CONNECT_WALLET_CLICK);
    openDialog('ConnectWallet');
  };

  return (
    <Button type="outlined" onClick={handleConnect} size="m" className={className}>
      <Trans id="connect_wallet" message="Connect wallet" />
      <Icon icon="chevron" className={styles.chevron} />
    </Button>
  );
}
